import {OnInit, Type, ViewChild, ElementRef, Directive, EventEmitter} from '@angular/core';
import { IAtpEntity, IAtpPaginationDynamicTable, AtpFiltersPanelItem, IAtpPropertyInfo, getFiltersPanelItems, AtpAddEditData, IAtpAddEditInfo, IAtpAddEditDataSettings, IAtpPaginationDynamicTreeTable, IAtpAnnotations, EventArgs, IAtpSelectItem, AtpHistoryData, IAtpHistory, IAtpPagination } from '../atp-core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { Subscription } from 'rxjs';
import { AtpTableActionsMenu, AtpTableActionsMenuItem, AtpEnabledTableActionsMenuItem } from '../components/atp-table-actions-menu/atp-table-actions-menu.component';
import {ComponentPortal, ComponentType, Portal} from '@angular/cdk/portal';
import { AtpActionsPopup, AtpActionsPopupData } from '../components/atp-actions-popup/atp-actions-popup.component';
import { AtpHttpService, IAtpUser, IAtpUnitAccess } from '../services/atp-http.service';
import { AtpHttpErrorsService, AtpHttpErrorHandler } from '../services/atp-http-errors.service';
import { AtpDialogService } from '../components/atp-dialog/atp-dialog.service';
import { AtpDialogRef } from '../components/atp-dialog/atp-dialog-container.component';
import { AtpAddEditPopupDynamicTableFullCrud } from './atp-dynamic-form/atp-add-edit-popup-dynamic-table-full-crud';
import { AtpAddEditDynamicTableFullCrud } from './atp-dynamic-form/atp-add-edit-dynamic-table-full-crud';
import { AtpBasePageComponent } from '../atp-base-page-component';
import { Location } from '@angular/common';
import { AtpMovementTreeComponent, AtpMovementTreeData } from './atp-movement-tree/atp-movement-tree.component';
import { AtpSectionDirective } from '../components/atp-section/atp-section.directive';
import { Platform } from '@angular/cdk/platform';
import { AtpHistoryComponent } from './atp-history/atp-history.component';
import {CdkPortalOutletAttachedRef} from "@angular/cdk/portal/portal-directives";

@Directive()
export abstract class AtpDynamicTableFullCrudComponent<TEntity extends IAtpEntity, THttpService extends AtpHttpService<IAtpUser>> extends AtpBasePageComponent implements OnInit {

  constructor(protected api: THttpService, protected httpErrors: AtpHttpErrorsService, protected elementRef: ElementRef<HTMLElement>,
    protected platform: Platform, protected activatedRoute: ActivatedRoute, protected router: Router, protected location: Location,
    protected dialog: MatDialog, protected atpDialog?: AtpDialogService) {
    super();
  }

  protected titleHide: boolean = false;

  portalBlockActions: Portal<any>;
  emptyResultBlock: Portal<any>;

  recieveReference(portalRef: CdkPortalOutletAttachedRef) { }

  id: any;

  private _treeAllElements: boolean = false;
  get treeAllElements(): boolean {
    return this._treeAllElements;
  }
  set treeAllElements(value: boolean) {
    if (!this.id) {
      this._treeAllElements = value;

      this.getData();
    }
  }

  access: IAtpUnitAccess;

  /**
   * Название сущности
   */
  private _type: string;
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this.setType(value);
  }

  protected setType(value: string) {
    if (this.annotations && this.annotations.access) {
      this._type = value;
      this.access = this.api.getAccess((this.annotations.access.name ? this.annotations.access.name + '.' : '') + value);
      this.setMultipleActionsMenu();
      this.setSingleActionsMenu();
    }
    else {
      this._type = value;
    }
  }

  get annotations(): IAtpAnnotations {
    return (<any>this.constructor).__atpannotations__;
  }

  baseGroupName: string;
  isChangeType = true;

  backUrl: string;

  addEditSettings: IAtpAddEditDataSettings = {};

  tableData: IAtpPaginationDynamicTable<TEntity> | IAtpPaginationDynamicTreeTable<TEntity>;

  displayedColumns: string[];
  displayedColumnTitles: string[];

  isNotData = false;

  pageSizeOptions: number[] = [25, 50, 100];

  dataSource = new MatTableDataSource<TEntity>();

  selection = new SelectionModel<TEntity>(true, []);

  singleActionsMenu = new AtpTableActionsMenu('Single');
  multipleActionsMenu = new AtpTableActionsMenu('Multiple');

  pageInfo: PageEvent;
  sortInfo: Sort;

  filtersPanelItems: AtpFiltersPanelItem<any>[] = [];
  filtrationParams: string;

  protected navigateSubscription: Subscription;

  private _topSection: AtpSectionDirective;
  @ViewChild('topSection', { read: AtpSectionDirective }) get topSection(): AtpSectionDirective {
    return this._topSection;
  }
  set topSection(value: AtpSectionDirective) {
    if (!this.platform.TRIDENT) {
      if (value) {
        this.tableMaxHeight = value.height.toString();
        value.heightChanged.subscribe(
          (data: EventArgs<AtpSectionDirective, number>) => {
            this.tableMaxHeight = data.e.toString();
          }
        );
      }

      this._topSection = value;
    }
  }

  private _baseComponentHeight: number;

  private _tableMaxHeight: string = '0';
  get tableMaxHeight(): string {
    return this._tableMaxHeight;
  }
  set tableMaxHeight(value: string) {
    setTimeout(() => {
      if (+value < window.screen.height / 2) {
        if (this.elementRef) {
          if (!this._baseComponentHeight) {
            this._baseComponentHeight = this.elementRef.nativeElement.offsetHeight;
          }
          this._tableMaxHeight = `calc(${this._baseComponentHeight}px - ${value}px)`;
        }
        else {
          this._tableMaxHeight = `calc(100vh - ${value}px)`;
        }
      }
      else {
        this._tableMaxHeight = `50vh`;
      }
    }, 0);
  }

  filtrationClick(event: any) {
    this.router.navigate(['/' + (this.baseGroupName ? this.baseGroupName.toLowerCase() : ''), this.type], { queryParams: event.e });
  }

  resetClick(event: any) {
    this.router.navigate(['/' + (this.baseGroupName ? this.baseGroupName.toLowerCase() : ''), this.type]);
  }

  /**
   * Установка элементов меню одной сущности
   */
  protected setSingleActionsMenu() {
    this.singleActionsMenu.items = [];
    if (this.access && this.tableData) {
      if (this.access.canEdit) {
        this.singleActionsMenu.items.push(new AtpTableActionsMenuItem('Редактировать', 'edit', (model) => { this.edit(model); }));
        if (this.tableData.tableInfo.isTree) {
          this.singleActionsMenu.items.push(new AtpTableActionsMenuItem('Переместить', 'shuffle', (model) => { this.movement(model); }));
        }
      }
      if (this.access.canDisabled) {
        this.singleActionsMenu.items.push(new AtpEnabledTableActionsMenuItem((value, model) => { this.enabled(value, model); }));
      }
      if (this.access.canReadHistory) {
        this.singleActionsMenu.items.push(new AtpTableActionsMenuItem('История изменений', 'history', (model) => { this.history(model); }));
      }
      if (this.access.canDelete) {
        this.singleActionsMenu.items.push(new AtpTableActionsMenuItem('Удалить', 'delete', (model) => { this.delete(model); }));
      }
    }
  }

  /**
   * Установка элементов меню таблицы
   */
  protected setMultipleActionsMenu() {
    this.multipleActionsMenu.items = [];
    if (this.access) {
      if (this.access.canAdd) {
        this.multipleActionsMenu.items.push(new AtpTableActionsMenuItem('Добавить', 'add', (model) => { this.add(); }, false));
      }
      if (this.access.canDisabled) {
        this.multipleActionsMenu.items.push(new AtpTableActionsMenuItem('Активировать', null, (model) => { this.enabledMultiple(true); }));
        this.multipleActionsMenu.items.push(new AtpTableActionsMenuItem('Деактивировать', null, (model) => { this.enabledMultiple(false); }));
      }
      if (this.access.canReadHistory) {
        this.multipleActionsMenu.items.push(new AtpTableActionsMenuItem('История изменений', 'history', (model) => { this.history(null); }));
      }
      if (this.access.canDelete) {
        this.multipleActionsMenu.items.push(new AtpTableActionsMenuItem('Удалить', 'delete', (model) => { this.deleteMultiple(); }));
      }
    }
  }

  protected setTypeAndBaseGroupName() {
    this.type = this.type || (this.annotations.name ? this.annotations.name.toLowerCase() : undefined);
    this.baseGroupName = this.baseGroupName || this.annotations.baseGroupName || (this.type ? this.type[0].toUpperCase() + this.type.substr(1) : '');
  }

  /**
   * Установка события изменения роута
   */
  protected setNavigateSubscription() {
    this.navigateSubscription = this.activatedRoute.data.subscribe(
      data => {
        const params = data.resolver.params;

        this.pageInfo = new PageEvent();
        this.pageInfo.pageIndex = (params.pageNumber - 1) || 0;
        this.pageInfo.pageSize = params.pageSize || this.pageSizeOptions[0];
        this.sortInfo = params.sortField ? { active: params.sortField, direction: params.sortDirection == 'asc' ? 'asc' : 'desc' } : this.sortInfo ? this.sortInfo : null;

        this.setTypeAndBaseGroupName();

        this.addEditSettings.baseGroupName = this.baseGroupName;

        this.backUrl = data.resolver.backUrl || '/';
        this.filtrationParams = data.resolver.queryParamsString;

        this.getDataFromNavigate(params);
      }
    );
  }

  protected getDataFromNavigate(params: any) {
    this.id = params.id;
    this.getData(params.type === undefined ? (this.type || this.baseGroupName) : params.type);
  }

  ngOnInit() {
    this.setTypeAndBaseGroupName();
    this.setNavigateSubscription();

    window.addEventListener("orientationchange", this.orientationChange.bind(this), false);
  }

  private orientationChange() {
    if (this._topSection) {
      this._tableMaxHeight = '0';
      this._baseComponentHeight = 0;
      this.tableMaxHeight = this._topSection.height.toString();
    }
  }

  ngOnDestroy() {
    window.removeEventListener("orientationchange", this.orientationChange.bind(this), false);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.tableData.items.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.tableData.items.forEach(row => this.selection.select(row));
  }

  /**
   * Изменение роута, в соответствии с пагинацией и сортировкой
   */
  protected replaceStateLocation() {
    this.location.replaceState('/' + this.baseGroupName + '/' + this.type + '/' + (this.pageInfo.pageIndex + 1) + '/' + this.pageInfo.pageSize + '/' + this.sortInfo.active + '/' + this.sortInfo.direction);
  }

  pagination(event: PageEvent): void {
    this.pageInfo = event;
    this.replaceStateLocation();
    this.getData();
  }

  sort(event: Sort): void {
    this.sortInfo = event;
    this.replaceStateLocation();
    this.getData();
  }

  /**
   * Получение данных
   * @param type название сущности, взятое из роута
   */
  getData(type: string = undefined) {
    this.isBlockedPage = true;
    type = type === undefined ? this.type : type;
console.log([this.id, this.treeAllElements, this.tableData, this.tableData?.tableInfo.isTree]);
    let observable =
      (this.tableData && !this.tableData.tableInfo.isTree) ||
      (!this.id && !this.treeAllElements) ?
      this.api['get' + this.baseGroupName](type, this.pageInfo.pageIndex + 1, this.pageInfo.pageSize, this.sortInfo ? this.sortInfo.active : '', this.sortInfo ? this.sortInfo.direction : '', this.filtrationParams) :
      this.api['get' + this.baseGroupName + 'Tree'](type, this.id, !this.id && this.treeAllElements, this.pageInfo.pageIndex + 1, this.pageInfo.pageSize, this.sortInfo ? this.sortInfo.active : '', this.sortInfo ? this.sortInfo.direction : '', this.filtrationParams);

    observable.subscribe(
      (result: IAtpPaginationDynamicTable<TEntity> | IAtpPaginationDynamicTreeTable<TEntity>) => {
        this.sortInfo = this.sortInfo || <Sort>result.tableInfo;
        this.sortInfo.active = result.propertiesInfo.find(x => x.name.toUpperCase() == this.sortInfo.active.toUpperCase()).name;

        this.displayedColumns = ['actions'].concat((<IAtpPropertyInfo[]>result.propertiesInfo).map((fieldInfo: IAtpPropertyInfo): string => { return fieldInfo.name; }));
        this.displayedColumnTitles = [''].concat((<IAtpPropertyInfo[]>result.propertiesInfo).map((fieldInfo: IAtpPropertyInfo): string => { return fieldInfo.display; }));
        this.tableData = result;
        this.dataSource.data = this.tableData.items;
        this.addEditSettings.isTree = this.tableData.tableInfo.isTree;

        this.selection.clear();

        this.isBlockedPage = false;
        this.isNotData = this.tableData.items.length == 0;

        this.isChangeType = this.type != type;
        if (this.isChangeType || !this.filtersPanelItems.length) this.filtersPanelItems = getFiltersPanelItems(this.tableData.propertiesInfo, this);

        this.type = type;
        this.multipleActionsMenu.isDisabled = false;

        this.getDataCorrectResult(result);
      },
      err => {
        this.multipleActionsMenu.isDisabled = true;
        this.httpErrors.process(err.status, () => { this.getData(type); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  protected getDataCorrectResult(result: IAtpPaginationDynamicTable<TEntity>) {
  }

  // TODO: рефакторинг
  /**
   * Получение типа внедряемого компонента для действия
   * @param type тип действия
   */
  protected getEntryComponent(type: 'Add' | 'Edit' | 'Actions' | 'History'): Type<{}> | ComponentType<{}> {
    let result: ComponentType<{}>;
    if (type == 'Actions') {
      if (this.annotations && this.annotations.entryComponents) {
        result = this.annotations.entryComponents[(type + 'Popup' + this.type + 'Component').toUpperCase()];
        result = result || this.annotations.entryComponents[(type + 'PopupComponent').toUpperCase()];
      }
      if (!result) return AtpActionsPopup;
    }
    else if (type == 'History') {
      if (this.annotations && this.annotations.entryComponents) {
        result = this.annotations.entryComponents[(type + 'Popup' + this.type + 'Component').toUpperCase()];
      }
      if (!result) return AtpHistoryComponent;
    }
    else {
      if (this.annotations && this.annotations.entryComponents) {
        result = this.annotations.entryComponents[(type + (!this.atpDialog ? 'Popup' : '') + this.type + 'Component').toUpperCase()];
        result = result || this.annotations.entryComponents[('AddEdit' + (!this.atpDialog ? 'Popup' : '') + this.type + 'Component').toUpperCase()];
        result = result || this.annotations.entryComponents[('AddEdit' + (!this.atpDialog ? 'Popup' : '') + this.baseGroupName + 'Component').toUpperCase()];
      }
      if (!result) return !this.atpDialog ? AtpAddEditPopupDynamicTableFullCrud : AtpAddEditDynamicTableFullCrud;
    }

    return result;
  }

  protected getAddEditContainer(type: 'Add' | 'Edit', data: AtpAddEditData<any, IAtpAddEditInfo>): AtpDialogRef<{}, any> | MatDialogRef<{}, any> {
    if (this.atpDialog) {
      return this.atpDialog.open(<ComponentType<{}>>this.getEntryComponent(type), { data });
    }
    else {
      return this.dialog.open(this.getEntryComponent(type), {
        width: '500px',
        maxHeight: '80%',
        data: data
      });
    }
  }

  /**
   * Добавление
   */
  add(): void {
    this.isBlockedPage = true;
    this.api['addInfo' + this.baseGroupName](this.type).subscribe(
      (result: IAtpAddEditInfo) => {
        this.getAddEditContainer('Add', new AtpAddEditData(this.type, null, result, this.addEditSettings, this.tableData.tableInfo.isTree ? { parentId: this.id } : undefined)).afterClosed().subscribe(result => {
          if (result) {
            this.getData();
          }
        });
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.add(); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  /**
   * Изменение
   * @param model сущность
   */
  edit(model: TEntity): void {
    this.isBlockedPage = true;
    this.api['editInfo' + this.baseGroupName](this.type, model.id).subscribe(
      (result: IAtpAddEditInfo) => {
        this.getAddEditContainer('Edit', new AtpAddEditData(this.type, result.model, result, this.addEditSettings)).afterClosed().subscribe(result => {
          if (result) {
            this.getData();
          }
        });
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.edit(model); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  protected getNameForAction(model: TEntity): string {
    return model.name;
  }

  /**
   * Удаление
   * @param model сущность
   */
  delete(model: TEntity): void {
    let data = new AtpActionsPopupData('Удаление', 'Вы действительно хотите удалить ' + (this.getNameForAction(model) ? '"' + this.getNameForAction(model) + '"' : 'выбранный элемент') + '?');
    data.successBtnColor = 'warn';
    data.titleColor = '#FF0000';
    this.dialog.open(this.getEntryComponent('Actions'), {
      width: '450px',
      data: data,
    }).afterClosed().subscribe(result => {
      if (!result) return;
      this.deleteQuery(model.id);
    });
  }

  /**
   * Удаление выделенных сущностей
   */
  deleteMultiple(): void {
    if (this.selection.selected.length == 0) {
      let data = new AtpActionsPopupData('Удаление', 'Необходимо выбрать элементы для удаления.', 'Закрыть', null);
      data.successBtnColor = 'warn';
      data.titleColor = '#FF0000';
      this.dialog.open(this.getEntryComponent('Actions'), {
        width: '450px',
        data: data,
      });
      return;
    }

    let data = new AtpActionsPopupData('Удаление', 'Вы действительно хотите удалить выбранные элементы?');
    data.successBtnColor = 'warn';
    data.titleColor = '#FF0000';
    this.dialog.open(this.getEntryComponent('Actions'), {
      width: '450px',
      data: data,
    }).afterClosed().subscribe(result => {
      if (!result) return;

      let ids: string[] = [];
      this.selection.selected.forEach(element => {
        ids.push(element.id);
      });

      this.deleteQuery(ids);
    });
  }

  private deleteQuery(ids: any) {
    this.isBlockedPage = true;
    this.api['delete' + this.baseGroupName](this.type, ids).subscribe(
      (data: boolean) => {
        this.isBlockedPage = false;

        this.getData();
      },
      err => {
        this.httpErrors.process(err.status, () => { this.deleteQuery(ids); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  /**
   * Активация/деактивация
   * @param value значение
   * @param model сущность
   */
  enabled(value: boolean, model: TEntity, titleActivated?: string, titleDactivated?: string, activatedName?: string, deactivatedName?: string): void {
    let title = value ? (titleActivated || 'Активация') : (titleDactivated || 'Деактивация');
    let data = new AtpActionsPopupData(title, 'Вы действительно хотите ' + (value ? (activatedName || 'активировать') : (deactivatedName || 'деактивировать')) + ' ' + (this.getNameForAction(model) ? '"' + this.getNameForAction(model) + '"' : 'выбранный элемент') + '?');
    data.successBtnColor = 'accent';
    data.titleColor = '#ff4081';
    this.dialog.open(this.getEntryComponent('Actions'), {
      width: '450px',
      data: data,
    }).afterClosed().subscribe(
      (result: boolean) => {
        if (!result) return;

        this.enabledQuery(value, model.id);
      }
    );
  }

  /**
   * Активация/деактивация выделенных сущностей
   * @param value значение
   */
  enabledMultiple(value: boolean, titleActivated?: string, titleDactivated?: string, activatedName?: string, deactivatedName?: string): void {
    let title = value ? (titleActivated || 'Активация') : (titleDactivated || 'Деактивация');
    if (this.selection.selected.length == 0) {
      let data = new AtpActionsPopupData(title, 'Необходимо выбрать элементы.', 'Закрыть', null);
      data.successBtnColor = 'accent';
      data.titleColor = '#ff4081';
      this.dialog.open(this.getEntryComponent('Actions'), {
        width: '450px',
        data: data,
      });
      return;
    }

    let data = new AtpActionsPopupData(title, 'Вы действительно хотите ' + (value ? (activatedName || 'активировать') : (deactivatedName || 'деактивировать')) + ' выбранные элементы?');
    data.successBtnColor = 'accent';
    data.titleColor = '#ff4081';
    this.dialog.open(this.getEntryComponent('Actions'), {
      width: '450px',
      data: data,
    }).afterClosed().subscribe(
      (result: boolean) => {
        if (!result) return;

        let ids: string[] = [];
        this.selection.selected.forEach(element => {
          ids.push(element.id);
        });

        this.enabledQuery(value, ids);
      }
    );
  }

  private enabledQuery(value: boolean, ids: any) {
    this.isBlockedPage = true;
    this.api['enabled' + this.baseGroupName](this.type, value, ids).subscribe(
      (result: boolean) => {
        this.isBlockedPage = false;
        this.getData();
      },
      err => {
        this.httpErrors.process(err.status, () => { this.enabledQuery(value, ids); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  movement(model: TEntity) {
    let data = new AtpMovementTreeData(
      'Перемещение',
      model.id,
      this.baseGroupName,
      this.type,
      this.tableData.tableInfo.title,
      true
    );

    const dialogRef = this.dialog.open(AtpMovementTreeComponent, {
      maxHeight: '80vh',
      data: data,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  getColumnClasses(index: number): string[] {
    let result: string[] = [];
    const actionsItemsCount = (this.multipleActionsMenu && this.multipleActionsMenu.items && this.multipleActionsMenu.items.filter(x => x.needModel).length ? this.multipleActionsMenu.items.filter(x => x.needModel).length : 0) +
      (this.singleActionsMenu && this.singleActionsMenu.items && this.singleActionsMenu.items.length ? this.singleActionsMenu.items.length : 0);
    if (index == 0) {
      result.push('atp-dynamic-table-full-crud__actions-column');
      if (actionsItemsCount == 0) {
        result.push('atp-dynamic-table-full-crud__actions-column_empty');
      }
      else if (actionsItemsCount == 1) {
        result.push('atp-dynamic-table-full-crud__actions-column_single');
      }
    }
    else {
      result.push(`atp-dynamic-table-full-crud__${this.baseGroupName.toLowerCase()}-column_${this.displayedColumns[index].toLowerCase()}`);
      result.push(`atp-dynamic-table-full-crud__${this.baseGroupName.toLowerCase()}-${this.type.toLowerCase()}-column_${this.displayedColumns[index].toLowerCase()}`);
      if (index == 1) {
        result.push('atp-dynamic-table-full-crud__sticky-column');
        if (actionsItemsCount == 0) {
          result.push('atp-dynamic-table-full-crud__sticky-column_empty-menu');
        }
        else if (actionsItemsCount == 1) {
          result.push('atp-dynamic-table-full-crud__sticky-column_single-menu');
        }
      }
    }

    return result;
  }

  get needCheckboxAction(): boolean {
    return !!(this.multipleActionsMenu && this.multipleActionsMenu.items && this.multipleActionsMenu.items.filter(x => x.needModel).length);
  }

  protected getHistoryContainer(data: AtpHistoryData): AtpDialogRef<{}, any> | MatDialogRef<{}, any> {
    if (this.atpDialog) {
      return this.atpDialog.open(<ComponentType<{}>>this.getEntryComponent('History'), { data });
    }
    else {
      return this.dialog.open(this.getEntryComponent('History'), {
        width: '500px',
        maxHeight: '80%',
        data: data
      });
    }
  }

  history(model: TEntity): void {
    this.isBlockedPage = true;
    this.api['history' + this.baseGroupName](this.type, model ? model.id : null, 1, 15).subscribe(
      (result: IAtpPagination<IAtpHistory>) => {
        let userIdsItems = {};
        for (const item of result.items) {
          if (!item.userId) {
            continue;
          }
          if (!userIdsItems[item.userId]) {
            userIdsItems[item.userId] = [];
          }
          userIdsItems[item.userId].push(item);
        }
        this.getUserNamesByIds(model ? model.id : null, userIdsItems, result);
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.history(model); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  protected getUserNamesByIds(modelId: any, userIdsItems: any, data: IAtpPagination<IAtpHistory>): void {
    this.isBlockedPage = true;
    this.api.getUserNamesByIds(Object.getOwnPropertyNames(userIdsItems)).subscribe(
      (users: IAtpSelectItem[]) => {
        for (const key in userIdsItems) {
          const user = users.find(x => x.id == key);
          for (const item of userIdsItems[key]) {
            item.userName = user.value;
            item.roleName = (<any>user).roleName;
          }
        }

        this.getHistoryContainer(new AtpHistoryData(this.baseGroupName, this.type, modelId, data, this.backUrl));
        this.isBlockedPage = false;
      },
      err => {
        this.httpErrors.process(err.status, () => { this.getUserNamesByIds(modelId, userIdsItems, data); }, this, [new AtpHttpErrorHandler(400, err.error)], this.backUrl);
      }
    );
  }

  actionEvent(e) {}
}
